import React from "react";
import { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./FmSimpleCarusel.css";
import "./FmSimpleCarusel.style.ts";
import { useWindowDimensions } from "../../Hooks";
import useStyles from "./FmSimpleCarusel.style";

interface FmSimpleCaruselProps {
    data: {
        img: string;
        title: string;
        description: string;
    }[];
}

export default function FmSimpleCarusel({ data }: FmSimpleCaruselProps) {
    const [slideIndex, setSlideIndex] = useState<number>(0);

    const classes = useStyles();

    const { width } = useWindowDimensions();

    let slidesPadding = "120px";
    let slidePictureContainer = classes.slider_container;

    if (width < 1500) {
        slidesPadding = "0px";
        slidePictureContainer = classes.slidePictureSmallScreen;
    }

    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: slidesPadding,
        slidesToShow: 1,
        speed: 500,
        dots: true,
        arrows: false,
    };

    return (
        <div className={classes.carusel_container}>
            <Slider
                {...settings}
                beforeChange={(_, newIndex) => {
                    setSlideIndex(newIndex);
                }}
            >
                {data.map((slide) => (
                    <div key={slide.title} className={slidePictureContainer}>
                        <img src={slide.img} alt={slide.title} title={slide.title} />
                    </div>
                ))}
            </Slider>
            <h1 className={classes.carusel_title}>{data[slideIndex].title}</h1>
            <h3 className={classes.carusel_description}>{data[slideIndex].description}</h3>
        </div>
    );
}
